import Vue from "vue";

import HttpDriver from "@websanova/vue-auth/drivers/http/axios.1.x";
import RouterDriver from "@websanova/vue-auth/drivers/router/vue-router.2.x";

import config from "config";
import { getIdentifierHeaders } from "@zuldigital/utils";


export default {
  auth: {
    request(req, token) {
      const city = localStorage.getItem("X-City") || null;

      const headers = {
        Authorization: `Bearer ${token}`,
        ...getIdentifierHeaders()
      };

      if (city && req.url !== this.options.loginData.url) {
        headers["X-City"] = city;
      }

      this.options.http._setHeaders.call(this, req, headers);
    },
    response(res) {
      const allowedUrls = [
        this.options.loginData.url,
        this.options.refreshData.url,
        this.options.redefineUrl
      ];

      const shouldSaveOnOTP = res.status === 426 && res.config.url === this.options.loginData.url;
      const shouldSaveAccessToken = (res.status === 200 && allowedUrls.includes(res.config.url)) || shouldSaveOnOTP;

      if (shouldSaveAccessToken) {
        // Tokens
        Vue.auth.token("access_token", res.headers["x-auth-token"]);
        // Vue.auth.token("refresh_token", res.data.refreshToken);

        // User data
        const userData = JSON.parse(atob(Vue.auth.token().split(".")[1]))
        Vue.auth.user(userData);
      }

      const headers = this.options.http._getHeaders.call(this, res);
      let token;

      if (headers) {
        token = headers.Authorization;
      }

      if (token) {
        token = token.split("Bearer ");
        return token[token.length > 1 ? 1 : 0];
      }
    }
  },
  http: HttpDriver,
  router: RouterDriver,
  requestOtpData: {
    url: `${config.ZUL_API_URL}/login/request-otp`,
  },
  loginData: {
    url: `${config.ZUL_API_URL}/auth/login`,
    method: "POST",
    redirect: "/",
    fetchUser: false
  },
  fetchData: {
    enabled: false
  },
  refreshData: {
    url: `${config.ZUL_API_URL}/auth/refreshToken`,
    method: "POST",
    enabled: false
  },
  recoverUrl: `${config.ZUL_API_URL}/auth/password/resend`,
  redefineUrl: `${config.ZUL_API_URL}/auth/password/reset`,
  parseUserData() {
    try {
      return JSON.parse(atob(Vue.auth.token().split(".")[1]));
    } catch (e) {
      return null;
    }
  },
  rolesVar: "role",
  tokenDefaultName: "access_token"
};
